import { ReactNode } from 'react';
import SidebarNavList from './SidebarNavList';

type SideBarProps = {
  children: ReactNode;
};

function SideBar({ children }: SideBarProps) {
  return (
    <>
      <div className={'lnb-wrap'}>
        <SidebarNavList />
      </div>
      {children}
    </>
  );
}

export default SideBar;
